import React from 'react';
import { benefits } from '../mock';
import { Dumbbell, Moon, Zap, ShieldCheck } from 'lucide-react';

const iconMap = { Dumbbell, Moon, Zap, ShieldCheck };

export default function Benefits() {
  return (
    <section id="benefits" className="px-5 sm:px-8 mt-24">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid lg:grid-cols-2 gap-6 items-end pb-10">
          <div>
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="tag-dot" /> What it does
            </div>
            <h2 className="font-grotesk mt-3 text-4xl sm:text-5xl tracking-[-0.02em] font-medium max-w-xl">
              One tablet. <span className="font-display italic text-teal">Four</span> life upgrades.
            </h2>
          </div>
          <p className="text-neutral-500 max-w-md lg:text-right">
            Magnesium is the mineral 68% of Indians are deficient in. TriMag delivers the 4 things you can’t afford to skip.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {benefits.map((b, i) => {
            const Icon = iconMap[b.icon] || Zap;
            return (
              <div key={b.id} className="group relative rounded-2xl border border-black/5 dark:border-white/5 p-6 bg-white dark:bg-neutral-950 hover-lift overflow-hidden">
                <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-teal-soft dark:bg-white/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative flex items-center justify-between">
                  <div className="h-11 w-11 rounded-xl bg-[color:var(--cv-teal-soft)] dark:bg-white/5 inline-flex items-center justify-center text-teal">
                    <Icon size={20} />
                  </div>
                  <div className="font-mono text-[11px] text-neutral-400">0{i+1}</div>
                </div>
                <h3 className="relative font-grotesk mt-6 text-xl font-semibold tracking-tight">{b.title}</h3>
                <p className="relative mt-2 text-[14px] text-neutral-500 leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
